import {Button, Form, Modal} from 'antd';
import {Processor, useApproveAccountMutation} from 'api/generated';
import {Formik} from 'formik';
import {FormItem, Select} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {enumKeys} from 'lib/utils';
import React, {useState} from 'react';
import {paymentProcessorLabels} from '../../lib/labels';

type Props = {
  accountId?: string | null;
};

export const ApproveAccount: React.FC<Props> = ({accountId}) => {
  const [isOpen, setOpen] = useState(false);
  const [approveAccount] = useApproveAccountMutation();
  if (!accountId) return null;

  const initialValues: {processor: Processor} = {
    processor: Processor.MONEIX_F
  };

  const handleSubmit = async (
    {processor}: typeof initialValues,
    {setSubmitting}: FormikHelpers<typeof initialValues>
  ) => {
    try {
      await approveAccount({
        variables: {id: accountId, processor}
      });
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} type="primary">
        Approve
      </Button>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Approve account"
            okText="Approve"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            onCancel={() => {
              setOpen(false);
              setTimeout(resetForm, 100);
            }}>
            <Form layout="vertical">
              <FormItem name="processor" label="Payment processor">
                <Select name="processor" placeholder="Select payment processor">
                  {enumKeys(Processor).map((processor) => (
                    <Select.Option key={processor} value={processor}>
                      {paymentProcessorLabels[processor]}
                    </Select.Option>
                  ))}
                </Select>
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
